import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from 'react-toastify';
import Swal from 'sweetalert2'
import { useDispatch, useSelector } from "react-redux";
import { getSellers, deleteSeller, clearSellerMsg } from "../../actions/sellerAction";
import $ from 'jquery';

const SellerList = (props) => {
    const dispatch = useDispatch();

    const[sellersList,setSellersList] = useState([]);
    const[userData,setUserData] = useState("");

    // useEffect for call Api's
    useEffect(() => {
        dispatch(getSellers());
        setUserData(JSON.parse(localStorage.getItem("userData")));
    }, [dispatch]);

    //get all the sellers list from reducer and set here
    const getSellerList = useSelector((state) => state.getSellerList.getSellerList)
    useEffect(() => {
        if (getSellerList && getSellerList?.data && getSellerList?.data?.status === true) {
            setSellersList(getSellerList?.data?.data);
        }
        if (getSellerList && getSellerList?.data && getSellerList?.data?.status === false) {
            toast.error(getSellerList?.data?.message,{theme: "dark",});
        }
    }, [getSellerList]);

    // Delete selected seller and set updated list
    const handleDeleteSeller = (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You want to delete this Seller?",
            icon: "warning",
            confirmButtonText: 'OK',
            showCancelButton: true,
        }).then(result => {
            if (result.isConfirmed) {
                dispatch(deleteSeller(id));
            }
        });
    };

    //get response of deleted seller and update the list
    const deletedSellerDtl = useSelector((state) => state.deleteSeller.deleteSeller)
    useEffect(() => {
        if(deletedSellerDtl && deletedSellerDtl?.data && deletedSellerDtl?.data?.status === true ){
            toast.success(deletedSellerDtl?.data?.message,{theme: "dark",});
            if ($.fn.DataTable.isDataTable('#myTable')) {
                $('#myTable').DataTable().destroy(); // Destroy the existing DataTable instance
            }
            dispatch(getSellers());
            dispatch(clearSellerMsg());
        } 
        else if(deletedSellerDtl && deletedSellerDtl?.data && deletedSellerDtl?.data?.status === false ){
            toast.success(deletedSellerDtl?.data?.message,{theme: "dark",});
        }
    }, [deletedSellerDtl,dispatch]);

    // impelement datatable from jquery
    useEffect(() => {
        sellersList && sellersList.length > 0 && $(document).ready(function () {
            $('#myTable').DataTable({
                bDestroy: true, 
                pageLength: 10
            });
        });
    }, [sellersList])

    return (
        <>
            <div className="dash-body">
                <div className="head-row">
                    <h3>Sellers</h3>
                    {(userData?.role === 1)?<>
                        <Link to={'/seller/create'} className="cus-btn"><i className="fa-solid fa-circle-plus"></i> Create New Seller </Link>
                    </>:''}
                </div>
                <div className="table-responsive dash-table data_tableUs">
                    <table id="myTable" width="100%" border={0} cellSpacing={0} cellPadding={0}>
                        <thead>
                            <tr>
                                {(userData?.role === 1)?<>
                                <th>EDIT</th>
                                <th>DELETE</th></>:''}
                                <th>SELLER NAME</th>
                                <th>EMAIL</th>
                                <th>PHONE NO.</th>
                                <th>ADDRESS</th>
                                <th>CITY</th>
                                <th>COUNTRY</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(sellersList.length > 0) ? (
                                <>
                                    {sellersList.map((seller, index) => (
                                        <tr key={seller.id}>
                                            {(userData?.role === 1)?
                                            <>
                                                <td>
                                                    <Link to={`/seller/update/${seller.id}`}><i className="fa-solid fa-pencil"></i></Link>
                                                </td>
                                                <td>
                                                    <Link onClick={() => {handleDeleteSeller(seller.id)}}><i className="fa-solid fa-trash-can-xmark"></i></Link>
                                                </td>
                                            </>:''}
                                            <td>{seller.name}</td>
                                            <td>{(seller.email )? seller.email  : '-'}</td>
                                            <td>{(seller.phone_no) ? seller.phone_no : '-'}</td>
                                            <td>{(seller.address) ? seller.address : '-'}</td>
                                            <td>{(seller.city) ? seller.city : '-'}</td>
                                            <td>{(seller.country) ? seller.country : '-'}</td>
                                        </tr>
                                    ))}
                                </>
                            ): (
                                <tr>
                                    <td colSpan={8} align={'center'}> No recent sellers available </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
};

export default SellerList;
